import type { Content } from '../Content';

export const MOCK_CONTENT = {} as Content;
